import { Component, Input, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-confirmation',
  imports: [TranslatePipe],
  templateUrl: './confirmation.component.html',
  styleUrl: './confirmation.component.scss',
})
export class ConfirmationComponent {
  @Input() title = 'LOGOUT';
  @Input() message = 'LOGOUT_CONFIRM_MESSAGE';
  @Input() confirmLabel = 'CONFIRM';
  @Input() cancelLabel = 'COMMON.CANCEL';

  activeModal = inject(NgbActiveModal);
}
